import { forwardRef, useEffect, useState } from "react";
import PasswordInput from "./PasswordInput";
import { PhoneInput } from "./PhoneInput";
import TextInput from "./TextInput";
import TimeInput from "./TimeInput";

/**
 * @param {Object} props
 * @param {String} props.id Input unique id Required
 * @param {String} props.type Input type (text, number..) Required
 * @param {String} props.label Input Title Required
 * @param {Object} props.value Input Return Value Required (empty or not)
 * @param {Function} props.onChange Update value on Input change
 * @param {Object} props.style Input additionnal style Optionnal
 * @param {Boolean} props.required Is Return Value Required Optionnal (false by default)
 * @param {Boolean} props.disabled Is disabled the input Optionnal (false by default)
 * @param {Boolean} props.edit Is the Inout in edit mode or not Optionnal (false by deBooleanfault)
 * @param {Boolean} props.error Apply different style if error is true
 * @param {} props.verify Verify function applied on Value when closing edit Mode (need to return a boolean and take a value parameter)
 */
export const Input = forwardRef(function Input(props, ref) {
  const {
    id,
    type,
    value,
    disabled,
    verify,
    min,
    max,
    step,
    onClick,
    version,
    onChange,
    required,
    error,
    helperText,
    ...rest
  } = props;

  const [inputError, setVerifyError] = useState(false);
  const [inputValue, setInputError] = useState(value);

  useEffect(() => {
    if (typeof verify === "function") {
      setVerifyError(!verify(value));
    }
  }, [verify, value]);

  useEffect(() => {
    setInputError(inputValue);
  }, [inputValue]);

  const _onClick = () => {
    onClick?.();
  };

  let InputComponent = TextInput;
  let role = "textbox";
  let customProps = {};

  switch (type) {
    case "text":
      InputComponent = TextInput;
      role = "textbox";
      break;
    case "time":
      InputComponent = TimeInput;
      role = "time";
      customProps = {
        min,
        max,
        step,
        type,
      };
      break;
    case "number":
      InputComponent = TextInput;
      role = "numberbox";
      customProps = {
        type,
      };
      break;
    case "phone":
      InputComponent = PhoneInput;
      role = "phone";
      customProps = {
        type,
      };
      break;
    case "password":
      InputComponent = PasswordInput;
      role = "password";
      customProps = {
        type,
      };
      break;
    case "email":
      InputComponent = TextInput;
      role = "email";
      customProps = {
        type,
      };
      break;
    default:
      InputComponent = TextInput;
  }

  return (
    <InputComponent
      id={id}
      ref={ref}
      value={value}
      onClick={_onClick}
      disabled={disabled}
      required={required}
      onChange={onChange}
      error={error || inputError}
      helperText={helperText}
      version={version}
      {...rest}
      {...customProps}
    />
  );
});
